import React from 'react';
import { labels } from '../data/labels';
import './Loader.css'

function Loader(props) {
    return (
        <div className={`xs-loader-container ${props.hide?'hide':''} `}>
            {(props.error ?
                <>
                    <i className="fa fa-exclamation-triangle xs-error-icon"></i>
                    <span className="xs-error-message">{labels['general.error_fetching_data']}</span>
                </>
                :
                <div className="xs-loader"></div>
            )}
        </div>
    );
}

export default Loader;